const MiniTextEditor = {
  props: ['value', 'width', 'regex'],
  model: { event: 'change' },
  computed: {
    styles () {
      return this.width ? { width: this.width + 'px' } : {}
    }
  },
  methods: {
    onChange (e) {
      let v = e.target.value;
      if (this.regex && !new RegExp(this.regex).test(v)) {
        this.$emit('input', null);
        return;
      }
      this.$emit('change', v);
    },
    onKeyDown (e) {
      let code = e.keyCode;
      if (this.regex && !new RegExp(this.regex).test(e.key)) {
        e.returnValue = false;
        return;
      }
      if (code == 13) {
        this.$emit('change', e.target.value);
        e.returnValue = false;
        return;
      }
    }
  },
  render (h) {
    return h('input', {
      domProps: { value: this.regex ? (new RegExp(this.regex).test(this.value) ? this.value : null) : this.value },
      class: 'r-mini-editor',
      style: this.styles,
      on: {
        change: this.onChange,
        keydown: this.onKeyDown
      }
    })
  }
}

export default {
  install: function (Vue) {
    Vue.component('mini-text-editor', MiniTextEditor)
  }
}